import { Cancel, Save, Warning } from '@mui/icons-material'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { useState } from 'react'

type Props = {
  open: boolean,
  closeModal: () => void,
  proceedButtonAction: () => any,
}

export default function SkipVerificationModal({ open, closeModal, proceedButtonAction }: Props) {
  // State
  const [confirmationText, setConfirmationText] = useState('')

  return <Dialog
    open={open}
    onClose={closeModal}
  >
    <DialogTitle
      sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
    >
      {<Warning color='warning' />} Confirmation Required
    </DialogTitle>
    <DialogContent>
      You have selected the <strong>Skip Verification</strong> option. This means that vouchers related to the assigned bundle will be automatically created for all selected students, <span style={{ textDecoration: 'underline' }} >without undergoing verification</span>. To confirm this action, please enter the phrase <span style={{ fontStyle: 'italic' }} >“skip verification”</span> in the text box below.
      <div style={{ paddingTop: '1rem' }} >
        <TextField
          label='Type here'
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
        />
      </div>
    </DialogContent>
    <DialogActions>
      <Button
        id='modal-btn-cancel'
        onClick={closeModal}
        startIcon={<Cancel />}
        color='error'
      >
        Cancel
      </Button>
      <Button
        id='modal-btn-proceed'
        onClick={proceedButtonAction}
        startIcon={<Save />}
        disabled={confirmationText !== 'skip verification'}
      >
        Proceed
      </Button>
    </DialogActions>
  </Dialog>
}
